import {
  SmartphoneIcon,
  ZapIcon,
  UsersIcon,
  SearchIcon,
  ClockIcon,
  NetworkIcon,
  LibraryIcon,
  BrainIcon,
  HardHatIcon,
  GraduationCapIcon,
  RulerIcon,
  LayersIcon,
  MountainIcon,
  Building2Icon,
  HomeIcon,
  DropletsIcon,
  PaintbrushIcon,
  ShieldCheckIcon,
  CalculatorIcon,
  WalletIcon,
  CalendarDaysIcon,
  BookOpenIcon,
  WrenchIcon,
  ConstructionIcon,
  type LucideIcon,
} from 'lucide-react';

export const BRAND = 'EbookStore';
export const PRODUCT_NAME = 'Mega Pack Técnico en Construcciones 360';
export const CHECKOUT_URL = 'https://mega-pack-tecnico-en-construccion-360.impultienda.ar/checkout';
export const PRODUCT_IMAGE =
  'https://cdn.magicpatterns.com/uploads/jd8KAEDazpjXLfdieGudoD/4e1a9222-90e3-4420-97c2-9c75bdc9c8ee.png';
export const PRICE = '$19.990 ARS';
export const PRICE_AMOUNT = '$19.990';
export const PRICE_CURRENCY = 'ARS';
export const SUPPORT_EMAIL = 'ebookstore028@gmail.com';

export const heroBadges: { label: string; icon: LucideIcon }[] = [
  { label: '100% digital', icon: SmartphoneIcon },
  { label: 'Acceso inmediato', icon: ZapIcon },
  { label: 'Material organizado para docentes e instructores', icon: UsersIcon },
];

export type ProblemBlock =
  | { kind: 'chips'; items: string[] }
  | { kind: 'text'; items: string[] }
  | { kind: 'question'; text: string }
  | { kind: 'flow'; lead?: string; items: string[] }
  | { kind: 'closing'; items: [string, string] };

export type FamiliarProblem = {
  icon: LucideIcon;
  title: string;
  blocks: ProblemBlock[];
};

export const familiarProblems: FamiliarProblem[] = [
  {
    icon: SearchIcon,
    title: 'Tenés que buscar material para cada clase',
    blocks: [
      {
        kind: 'chips',
        items: [
          'Planos',
          'Materiales',
          'Fundaciones',
          'Mampostería',
          'Hormigón',
          'Estructuras',
          'Cubiertas',
          'Instalaciones',
          'Terminaciones',
          'Seguridad',
          'Cómputo',
          'Presupuestos',
        ],
      },
      {
        kind: 'text',
        items: ['La información existe, pero está repartida entre apuntes, manuales, PDF, videos y materiales de años anteriores.'],
      },
      {
        kind: 'flow',
        lead: 'Y después todavía tenés que:',
        items: ['Buscar', 'Seleccionar', 'Ordenar', 'Explicar', 'Conectar'],
      },
    ],
  },
  {
    icon: ClockIcon,
    title: 'Preparar una buena clase lleva tiempo',
    blocks: [
      {
        kind: 'text',
        items: [
          'Teoría, ejemplos, esquemas, detalles constructivos y actividades... y volver a hacer prácticamente lo mismo la semana siguiente.',
        ],
      },
      { kind: 'closing', items: ['La información está en todos lados.', 'El problema es que está dispersa.'] },
    ],
  },
  {
    icon: NetworkIcon,
    title: 'Y hay otro problema...',
    blocks: [
      {
        kind: 'text',
        items: ['Si cada tema se enseña por separado, el estudiante aprende conceptos aislados sin comprender:'],
      },
      { kind: 'question', text: '¿Cómo se conecta todo dentro de una obra real?' },
      { kind: 'text', items: ['Una construcción no funciona por capítulos. Funciona como un sistema.'] },
      { kind: 'closing', items: ['No necesitás más información suelta.', 'Necesitás un sistema organizado para enseñar.'] },
    ],
  },
];

export const constructionStages = [
  'Planificar',
  'Interpretar',
  'Preparar',
  'Construir',
  'Instalar',
  'Terminar',
  'Controlar',
  'Presupuestar',
];

export const packTopics: { label: string; icon: LucideIcon }[] = [
  { label: 'Planos y documentación', icon: RulerIcon },
  { label: 'Materiales', icon: LayersIcon },
  { label: 'Suelos y fundaciones', icon: MountainIcon },
  { label: 'Estructuras', icon: Building2Icon },
  { label: 'Cubiertas', icon: HomeIcon },
  { label: 'Instalaciones sanitarias', icon: DropletsIcon },
  { label: 'Instalaciones eléctricas', icon: ZapIcon },
  { label: 'Terminaciones', icon: PaintbrushIcon },
  { label: 'Seguridad', icon: ShieldCheckIcon },
  { label: 'Cómputo', icon: CalculatorIcon },
  { label: 'Presupuesto', icon: WalletIcon },
  { label: 'Planificación', icon: CalendarDaysIcon },
];

export type ValueFeature = {
  icon: LucideIcon;
  title: string;
  body?: string;
  flowLead?: string;
  flow?: string[];
  listLead?: string;
  list?: string[];
};

export const valueFeatures: ValueFeature[] = [
  {
    icon: LibraryIcon,
    title: 'Información organizada',
    body: 'Encontrá rápidamente el tema, concepto o etapa de obra que necesitás trabajar.',
  },
  {
    icon: BrainIcon,
    title: 'Método estructurado',
    body: 'En lugar de saltar entre información dispersa, seguí una secuencia que acompaña el proceso constructivo.',
  },
  {
    icon: HardHatIcon,
    title: 'Todo el ciclo de una obra',
    flowLead: 'El sistema conecta:',
    flow: [
      'Planos',
      'Terreno',
      'Fundaciones',
      'Muros',
      'Estructuras',
      'Cubiertas',
      'Instalaciones',
      'Terminaciones',
      'Control',
      'Presupuesto',
    ],
  },
  {
    icon: GraduationCapIcon,
    title: 'Pensado para enseñar',
    listLead: 'Utilizalo para:',
    list: [
      'preparar clases',
      'explicar conceptos',
      'introducir nuevos temas',
      'acompañar actividades',
      'analizar situaciones',
      'mostrar detalles',
      'trabajar interpretación de planos',
      'plantear casos prácticos',
      'integrar diferentes contenidos',
    ],
  },
];


export const reuseMoments = [
  'tenés que preparar una clase',
  'necesitás explicar un detalle',
  'vas a trabajar con planos',
  'querés enseñar una etapa nueva',
  'necesitás una actividad',
  'querés mostrar errores frecuentes',
  'necesitás preparar un caso práctico',
  'estás desarrollando un proyecto integrador',
  'o simplemente querés consultar un concepto técnico',
];

export const valueClosing = ['Menos búsquedas.', 'Menos horas preparando material.', 'Más estructura para tus clases.'];

export const audience: { label: string; icon: LucideIcon }[] = [
  { label: 'Docentes de escuelas técnicas', icon: GraduationCapIcon },
  { label: 'Instructores de formación profesional', icon: HardHatIcon },
  { label: 'Profesores de materias vinculadas a Construcciones', icon: RulerIcon },
  { label: 'Formadores de oficios', icon: ConstructionIcon },
  { label: 'Estudiantes avanzados', icon: BookOpenIcon },
  { label: 'Personas vinculadas al sector que quieran reforzar conocimientos técnicos', icon: WrenchIcon },
];

export const testimonials = [
  {
    initials: 'MR',
    name: 'Martín Rodríguez',
    location: 'Córdoba Capital',
    quote:
      'Me sirvió muchísimo tener todos los contenidos organizados siguiendo el proceso real de una obra. Ahora puedo preparar las clases mucho más rápido y relacionar mejor planos, materiales y ejecución.',
  },
  {
    initials: 'LF',
    name: 'Luciana Fernández',
    location: 'Rosario, Santa Fe',
    quote:
      'El Atlas Visual y la guía de planos son de las herramientas que más uso. Hay temas que antes costaban explicar solamente con teoría y ahora puedo mostrarlos de una forma mucho más clara.',
  },
  {
    initials: 'FG',
    name: 'Federico Gómez',
    location: 'Mar del Plata, Buenos Aires',
    quote:
      'Lo que más me gustó es que no son temas sueltos. Está organizado desde los materiales y los planos hasta estructuras, instalaciones, cómputo y planificación. Es muy práctico para tener como material de consulta.',
  },
];

export const faqs: { q: string; a: string[] }[] = [
  {
    q: '¿Para quién es este sistema?',
    a: [
      'Para docentes, instructores, formadores, estudiantes y personas vinculadas al área de Construcciones que quieran disponer de contenidos técnicos organizados en un único sistema.',
    ],
  },
  { q: '¿Es un producto físico?', a: ['No.', 'Es un producto 100% digital.', 'No se realizan envíos físicos.'] },
  {
    q: '¿Qué recibo?',
    a: ['Recibís:', '10 volúmenes completos + 5 bonos prácticos.', 'Todo dentro del sistema Mega Pack Técnico en Construcciones 360.'],
  },
  {
    q: '¿Necesito ser profesional de la construcción?',
    a: ['No necesariamente.', 'Los contenidos están organizados de forma progresiva para facilitar la comprensión.'],
  },
  {
    q: '¿Me sirve para preparar clases?',
    a: ['Sí.', 'El sistema está pensado especialmente para reducir el tiempo dedicado a buscar, ordenar y conectar contenidos técnicos.'],
  },
  {
    q: '¿Cómo lo recibo?',
    a: ['Una vez realizada la compra, obtenés acceso digital al contenido mediante el sistema de entrega correspondiente.'],
  },
  {
    q: '¿Puedo consultarlo desde el celular?',
    a: ['Sí.', 'Podés acceder desde dispositivos compatibles como:', 'celular, tablet o computadora.'],
  },
  { q: '¿Es un pago único?', a: ['Sí.', '$19.990 ARS', 'Pago único por el producto.'] },
];

export const lastQuestion = {
  moments: [
    'Cuando tenés que preparar una clase, explicar estructuras o interpretar un plano...',
    'o cuando necesitás integrar todos los temas en un proyecto...',
  ],
  question: '¿Vas a volver a buscar todo desde cero?',
  paragraphs: ['¿O preferís un sistema organizado que te acompañe en todo el proceso?'],
  closing: ['Planificá.', 'Construí.', 'Enseñá.'],
};

export const finalStages = [
  'Planos',
  'Materiales',
  'Fundaciones',
  'Estructuras',
  'Instalaciones',
  'Obra',
  'Seguridad',
  'Cómputo',
  'Planificación',
];

export const recentBuyers = [
  { name: 'Mariana López', city: 'Tafí del Valle', province: 'Tucumán' },
  { name: 'Lucas Fernández', city: 'Purmamarca', province: 'Jujuy' },
  { name: 'Sofía Martínez', city: 'El Calafate', province: 'Santa Cruz' },
  { name: 'Martín Gómez', city: 'Villa General Belgrano', province: 'Córdoba' },
  { name: 'Valeria Díaz', city: 'Cafayate', province: 'Salta' },
  { name: 'Diego Romero', city: 'San Martín de los Andes', province: 'Neuquén' },
  { name: 'Carolina Sosa', city: 'Esquel', province: 'Chubut' },
  { name: 'Federico Álvarez', city: 'Villa Gesell', province: 'Buenos Aires' },
  { name: 'Lorena Torres', city: 'Merlo', province: 'San Luis' },
  { name: 'Pablo Ruiz', city: 'Chilecito', province: 'La Rioja' },
  { name: 'Gabriela Benítez', city: 'Gualeguaychú', province: 'Entre Ríos' },
  { name: 'Nicolás Herrera', city: 'Tandil', province: 'Buenos Aires' },
  { name: 'Florencia Castro', city: 'Humahuaca', province: 'Jujuy' },
  { name: 'Javier Medina', city: 'Puerto Madryn', province: 'Chubut' },
  { name: 'Natalia Acosta', city: 'Villa La Angostura', province: 'Neuquén' },
  { name: 'Sebastián Molina', city: 'Malargüe', province: 'Mendoza' },
];
